import React, { useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import { useSetAtom } from "jotai";
import { useCreateIntent } from "@/query/intent";
import { intentTableScrollToIntentIdAtom } from "@/atom/intentTable";
import { useAgentId, useModal } from "@/hook";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";
import { errorToast, successToast } from "@/component/Toast";


export const INTENT_ADD_MODAL_ID = "intent-add-modal-id";

const IntentAddModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();
    const skill = modal.getData(INTENT_ADD_MODAL_ID);

    const [name, setName] = useState<string>("");
    const [validation, setValidation] = useState<{ name: boolean; }>({ name: true });

    const { mutateAsync: createIntent, isPending: isCreating } = useCreateIntent(agentId, skill?.id);
    const setScrollToIntentId = useSetAtom(intentTableScrollToIntentIdAtom);

    const validate = () => {
        const currentValidation = {
            name: !!name && name.trim().length > 0
        };
        setValidation(currentValidation);
        return Object.values(currentValidation).every(value => value);
    };

    const onClickConfirm = async () => {
        if (!validate()) {
            return;
        }

        await createIntent( { name: name.trim() })
            .then((intent) => {
                successToast(intl.formatMessage({ id: "t001" }));
                setScrollToIntentId(intent.id);
                modal.close(INTENT_ADD_MODAL_ID);
            })
            .catch(() => {
                errorToast(intl.formatMessage({ id: "t002" }));
            });
    };

    return (
        <Modal id={INTENT_ADD_MODAL_ID}
               size="sm"
               title={intl.formatMessage({ id: "i03021" })}
               onClose={() => {
                   setValidation({ name: true });
                   setName("");
               }}
        >
            <div className="modal-body">
                <input required={!validation.name}
                       className={classNames(
                           "modal-input",
                           !validation.name && !name.trim() && "input-invalid"
                       )}
                       value={name}
                       placeholder={intl.formatMessage({ id: "i03022" })}
                       onChange={e => setName(e.target.value)}
                       
                />
                <div className="modal-btn-group">
                    <Button size="sm"
                            variant="secondary"
                            disabled={isCreating}
                            onClick={() => modal.close(INTENT_ADD_MODAL_ID)}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button size="sm"
                            variant="primary"
                            disabled={isCreating}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default IntentAddModal;
